import React from "react";
import { useApp } from "../../contexts/AppContext";
import { TEMARIO } from "../../constants/temario";
import { useAuth } from "../../contexts/AuthContext";

const TopicsProgress = () => {
  // Cambiamos 'user' por 'profile' que es lo que viene de Supabase ahora
  const { profile, isLoadingProfile } = useAuth();

  // Opcional: Mostrar un estado de carga o esqueleto
  if (isLoadingProfile) {
    return (
      <div className="flex-grow bg-white p-8 rounded-[2.5rem] card-shadow border border-slate-100 animate-pulse">
        <div className="h-8 w-48 bg-slate-200 rounded mb-8"></div>
        <div className="space-y-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-4 bg-slate-100 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex-grow bg-white p-8 rounded-[2.5rem] card-shadow border border-slate-100">
      <h3 className="text-lg font-extrabold mb-8 flex items-center gap-3">
        <span className="w-2 h-8 bg-blue-600 rounded-full"></span>
        Dominio del Temario Oficial
      </h3>
      <div className="space-y-6">
        {TEMARIO.map((topic) => {
          // Usamos optional chaining profile?.progress para evitar errores
          // si el perfil aún no tiene datos grabados
          const progress = profile?.progress?.[topic.id] || 0;

          return (
            <div key={topic.id}>
              <div className="flex justify-between mb-2">
                <span className="text-[11px] font-bold text-slate-600 uppercase tracking-tight">
                  {topic.title}
                </span>
                <span className="text-xs font-black text-blue-600">
                  {progress}%
                </span>
              </div>
              <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-blue-500 to-indigo-600 transition-all duration-1000 ease-out"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopicsProgress;
